import { render } from "./HintModal.vue?vue&type=template&id=5fefe2fa&scoped=true"
import script from "./HintModal.vue?vue&type=script&lang=js"
export * from "./HintModal.vue?vue&type=script&lang=js"

import "./HintModal.vue?vue&type=style&index=0&id=5fefe2fa&scoped=true&lang=css"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fefe2fa"]])

export default __exports__